var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"eee"}),_c('b-navbar',{attrs:{"toggleable":"lg"}},[_c('b-navbar-nav',[_c('b-nav-text',[_vm._v("start © 2010")])],1),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-text',[_vm._v("aktualizacja © 2022")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }